import { USER_ROLE_PERMISSIONS_FOR_STATES } from '../../../ng2/shared/constants/user-role-permissions-for-states.constant';

angular.module('nv.routes.main').config(function($stateProvider) {
  $stateProvider.state('main.cluster', {
    url: '/district',
    template: require('../../features/landing/cluster/nv-cluster.html'),
    controller: 'ClusterMasterCtrl',
    controllerAs: 'clusterCtrl',
    data: {
      roles: USER_ROLE_PERMISSIONS_FOR_STATES['main.cluster'],
    },
    params: {
      lastView: null,
      stateParams: null,
    },
    resolve: {
      currentUserAllClusterSchools: [
        'currentUser',
        function(currentUser) {
          return currentUser.join_role_clusterSchools();
        },
      ],
    },
    ncyBreadcrumb: {
      label: 'District',
    },
  });
});
